module.exports = __webpack_public_path__ + "media/images/placeholder/plugin_image-ebd1b1af5fc26af25987d71358f426f9.png";